<template>
  <div class="help-wrap_commitment-letter">
    <router-link to="/commitment-letter" class="help">
      <img src="../../assets/image/ic_money.png" alt="" />
      {{ text }}
    </router-link>
  </div>
</template>

<script>
import i18n from './i18n'

export default {
  name: 'CommitmentLetterDemo',
  data() {
    return {
      text: i18n.global.messages.value[i18n.global.locale.value].title
    }
  },
}
</script>

<style scoped>

.help-wrap_commitment-letter {
    text-align: center;
    
    .help {
      display: inline-block;
      font-size: 0.24rem;
      color: #a6b0bd;
      line-height: 0.4rem;

      img {
        margin: 0 0.1rem;
        width: 0.28rem;
        height: 0.28rem;
      }

      * {
        vertical-align: text-bottom;
      }
    }
  }
</style>
